import { resolveTextBlockContent } from './text-block';

interface PracticeAreaTagsBlockProps {
  content?: unknown;
}

const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

const decodeEntities = (input: string): string =>
  input.replace(/&(#x[0-9a-f]+|#[0-9]+|[a-z]+);/gi, (match, entity: string) => {
    if (entity[0] === '#') {
      const code =
        entity[1] === 'x' || entity[1] === 'X'
          ? parseInt(entity.slice(2), 16)
          : parseInt(entity.slice(1), 10);
      return Number.isFinite(code) ? String.fromCodePoint(code) : match;
    }
    const named = NAMED_ENTITIES[entity.toLowerCase()];
    return named ?? match;
  });

const parseNames = (html: string): string[] => {
  const text = decodeEntities(html.replace(/<[^>]*>/g, ' '));
  const names = text
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean);
  return Array.from(new Set(names));
};

export function PracticeAreaTagsBlock({ content }: PracticeAreaTagsBlockProps) {
  const names = parseNames(resolveTextBlockContent(content));
  if (names.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {names.map((name) => (
        <span
          key={name}
          className="inline-flex items-center justify-center rounded-md border border-[rgba(34,34,34,0.24)] bg-[rgba(34,34,34,0.04)] px-1.5 py-0.5 text-sm font-medium leading-[21px] text-[#222]"
        >
          {name}
        </span>
      ))}
    </div>
  );
}
